import jwtDecode from 'jwt-decode'
import { get, findIndex } from 'lodash'
import store from 'store'
import { ROLES } from 'constants/enums'

export const getToken = user => {
  return (user && user.access_token) || null
}

export const getUsername = user => {
  const token = getToken(user)
  const decoded = jwtDecode(token)

  return decoded
}

export const getFullName = user => {
  if (!user) {
    return ''
  }
  return `${user.firstName} ${user.lastName}`
}

export const getSignupRole = user => {
  if (!user) {
    return ''
  }

  if (user.grant && user.grant[0].u) {
    return user.grant[0].u
  }

  if (user.access_token) {
    return jwtDecode(user.access_token).grant[0].u
  }

  return ''
}

export const getActiveRole = (organization, options = {}) => {
  if (!organization) {
    return ''
  }

  if (organization.userType) {
    if (organization.id === ROLES.GBT.organizationId) {
      return options.returnOriginalUserType
        ? ROLES.GBT.apiUserType
        : ROLES.GBT.u
    }

    if (
      ROLES.IF_STAFF_SUPER.u === organization.userType &&
      organization.id !== ROLES.IF_STAFF_SUPER.organizationId
    ) {
      return options.returnOriginalUserType
        ? ROLES.IF_REGION.apiUserType
        : ROLES.IF_REGION.u
    }

    if (
      get(organization, 'hierarchyLevelType.value') === ROLES.OA.hierarchyType
    ) {
      return options.returnOriginalUserType ? ROLES.OA.apiUserType : ROLES.OA.u
    }

    if (
      get(organization, 'hierarchyLevelType.value') === ROLES.SOA.hierarchyType
    ) {
      return options.returnOriginalUserType
        ? ROLES.SOA.apiUserType
        : ROLES.SOA.u
    }

    return organization.userType
  }
}

export const getActiveOrganization = user => {
  if (store.get(`activeOrganization-${get(user, 'personId')}`)) {
    return JSON.parse(store.get(`activeOrganization-${get(user, 'personId')}`))
  }

  if (!get(user, 'userTypes')) {
    return {}
  }
  const userType = getSignupRole(user)
  const userTypes = user.userTypes.filter(
    item => get(item, 'userType').toLowerCase() === userType
  )
  let defaultOrganizationUserType = {}

  for (const key of userTypes) {
    defaultOrganizationUserType = {
      id: key.organizations[0].id,
      name: key.organizations[0].name,
      regionId: key.organizations[0].regionId,
      hierarchyLevelType: key.organizations[0].hierarchyLevelType,
      userType
    }
  }

  return defaultOrganizationUserType
}

export const getActiveOrganizationName = user => {
  return getActiveOrganization(user).name
}

export const getOrganizations = user => {
  if (!get(user, 'userTypes')) {
    return []
  }
  const organizationUserTypes = {}

  for (const key of user.userTypes) {
    organizationUserTypes[key.userType] = {
      organizations: key.organizations
    }
  }

  return organizationUserTypes
}

export const multipleOrganizations = user => {
  const organisations = getOrganizations(user)
  const keys = Object.keys(organisations)
  let hasMultiple = false
  // Roles with organizations array that has 0 length does not exist
  const countKeys = keys.reduce((prev, curr) => {
    return organisations[curr].organizations.length > 0 ? prev + 1 : 0
  }, 0)

  if (countKeys > 1) {
    return true
  }

  keys.forEach(key => {
    if (organisations[key].organizations.length > 1) {
      hasMultiple = true
    }
  })

  return hasMultiple
}

export const getLeaderId = user => {
  let activeAwardLeaderId = 0
  const activeOrganizationId = getActiveOrganization(user).id

  const leadersOrganizations = get(user, 'userTypes', []).find(
    type => get(type, 'userType') === ROLES.LEADER.u
  )

  activeAwardLeaderId = findIndex(
    get(leadersOrganizations, 'organizations', []),
    item => item.id === activeOrganizationId
  )

  return get(user, `awardLeaderIds[${activeAwardLeaderId}]`)
}

export const personId = user => {
  return get(user, 'personId')
}

export const getPhotoUrl = user => {
  return get(user, 'photoUrl')
}
